import { __makeTemplateObject } from "tslib";
import styled, { css } from 'styled-components';
import { Flex } from '../Flex';
var GroupContainer = styled(Flex)(function (_a) {
    var theme = _a.theme, horizontal = _a.horizontal;
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    flex-direction: column;\n\n    ", "\n  "], ["\n    flex-direction: column;\n\n    ",
        "\n  "])), horizontal && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      @media (min-width: ", ") {\n        flex-direction: row;\n      }\n    "], ["\n      @media (min-width: ", ") {\n        flex-direction: row;\n      }\n    "])), theme.breakpoints.sm));
});
export default GroupContainer;
var templateObject_1, templateObject_2;
//# sourceMappingURL=GroupContainer.js.map